export default __webpack_public_path__ + "static/media/heatmap.ae11af67.svg";